<template>
    <div class="inputs">
        <field-input v-model="form.trigger" placeholder="Trigger"></field-input>
        <search-user v-model="form.employer_id" filter="employers" placeholder="Employer" ></search-user>
        <search-user v-model="form.technician_id" filter="technicians" placeholder="Technician" ></search-user>
        <search-user v-model="form.inspector_id" filter="inspectors" :without-me="0" placeholder="Inspector" ></search-user>
        <field-select v-model="form.type" placeholder="Type">
            <option value="certificate">Certificate</option>
            <option value="recertificate">Recertificate</option>
            <option value="random">Random</option>
        </field-select>
    </div>
</template>

<script>
    export default {

        props: {
            form: {
                type: Object,
                required: true,
            }
        },
    }
</script>
